module.exports = {"320381001":"新安街道","320381002":"北沟街道","320381003":"墨河街道","320381004":"唐店街道","320381102":"瓦窑镇","320381103":"港头镇","320381105":"合沟镇","320381106":"草桥镇","320381107":"窑湾镇","320381108":"棋盘镇","320381109":"马陵山镇","320381110":"新店镇","320381111":"邵店镇","320381113":"时集镇","320381114":"高流镇","320381115":"阿湖镇","320381116":"双塘镇","320381401":"经济开发区","320381402":"锡沂高新技术产业开发区","320381403":"马陵山风景名胜区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320381.json
// module id = 792
// module chunks = 0